import classNames from "classnames";
import classes from "./B2CProductList.module.less";
import { type LineItem } from "~/features/cart/cart/models/CartData";
import { type ProductData } from "~/domains/product/types/ProductData";
import { B2CProductListItem } from "~/features/cart/B2CCart/components/B2CProductList/compoments/B2CProductListItem";
import { useIsMinDesktopSize } from "~/common/hooks/useMediaQuery";
import { IconButton } from "~/common/mui";
import { IconType } from "~/common/components/icon/IconType";
import { Icon } from "~/common/components/icon/Icon";
import { useTranslation } from "react-i18next";

interface Props {
  className?: string;
  items: {
    data: LineItem;
    product: ProductData;
  }[];
  onDelete?: (item: LineItem) => void;
  onChange?: (item: LineItem, changes: Partial<LineItem>) => void;
  onDeleteAll?: () => void;
}

export const B2CProductList = ({ items, className, onDeleteAll, onDelete, onChange }: Props) => {
  const { t } = useTranslation();
  const isDesktop = useIsMinDesktopSize();
  return (
    <div className={classNames(classes.root, className)}>
      {isDesktop && (
        <div className={classes.header}>
          <div className={classes.headerItem}>{t("cartPage.table.header.product.title")}</div>
          <div className={classes.headerItem}>{t("cartPage.table.header.quantity.title")}</div>
          <div className={classes.headerItem}>{t("cartPage.report.comment")}</div>
          <div className={classes.headerItem}>
            <IconButton color={"primary"} className={classes.iconButton} onClick={onDeleteAll}>
              <Icon type={IconType.Bin} size={16} />
            </IconButton>
          </div>
        </div>
      )}
      <div className={classes.itemList}>
        {items.map((item) => (
          <B2CProductListItem
            key={item.data.id}
            {...item}
            onDelete={() => onDelete?.(item.data)}
            onChange={(updates) => onChange?.(item.data, updates)}
          />
        ))}
      </div>
    </div>
  );
};
